<template lang="pug">
div.wrap-asset-uploader
  div(v-if="!defaultAsset").wrap-type-selector.f.flex-wrap.mb4
    div(v-for="item in assetTypes"
      @click="selectedType = item.type"
      v-if="!blobURL").f.fm.mr12.mb8.cursor-pointer
      v-icon(:color="(selectedType == item.type) ? pallete.$active_color : pallete.$secondary_text_color").mr4 {{item.icon}}
      span(:style="`color: ${(selectedType == item.type) ? pallete.$active_color : pallete.$secondary_text_color};`") {{item.name}}
    //- div(v-for="item in assetTypes"
      @click="selectedType = item.type"
      v-if="!blobURL || (blobURL && isImageFile && item.type != 'actor')").f.fm.mr12.mb8.cursor-pointer
      v-icon(:color="(selectedType == item.type) ? pallete.$active_color : pallete.$secondary_text_color").mr4 {{item.icon}}
      span(:style="`color: ${(selectedType == item.type) ? pallete.$active_color : pallete.$secondary_text_color};`").pt4 {{item.name}}

  div(v-if="!isUploading && !comoleteUpload" @click.stop).wrap-upload-area
    //- input(ref="inputFile"
      type="file"
      @change="dropFile"
      webkitdirectory).input-file
    div(v-if="defaultAsset").f.flex-right.mb12
      span(@click="initializeContentToEditAsset(defaultAsset)"
        ).btn-cancel-upload.fz14.cursor-pointer キャンセル
    input(ref="inputFile"
      type="file"
      @change="dropFile").input-file
    div(@click.stop="onDragArea"
      @dragenter="isEnter = true"
      @dragleave="isEnter = false" 
      @dragover.prevent
      @drop.prevent="dropFile"
      :class="{'is-enter': isEnter}").drag-area.f.fh.cursor-pointer
      div.slide-uploader-content
        div.f.fc.mb2
          v-icon(:color="(isEnter) ? pallete.$active_color : pallete.$primary_text_color"
            size="60px") mdi-file-upload-outline
        span.text-center.fz14.block.bold.mb2 アップロード
        span.text-center.fz12.block {{allowedExtsText}}
  div.f.fm.flex-between.py2
    div(v-if="isUploading").f.fm.mb4
      v-progress-circular(size="18" width="2" indeterminate).mr4
      span.text-center.fz12.block アップロード中 {{Math.floor(uploadProgress)}}%
    div(v-if="comoleteUpload").f.fm.mb4
      v-icon.mr4 mdi-check-circle-outline
      span.text-center.fz12.block アップロード完了
    div(v-if="isUploading || comoleteUpload").wrap-reset
      span(@click="onReset").btn-reset.fz14.cursor-pointer {{ defaultAsset ? '素材データを更新' : 'キャンセル' }}

  //- actor
  div(v-if="selectedType === 'actor' && blobURL && assetExt == 'vrm'").wrap-actor-registor
    div.wrap-actor-photo-studio
      ItemActorPhotoStudio(ref="actorPhotoStudio"
        :vrmPath="blobURL" :defaultAsset="defaultAsset"
        @closeModal="showModal = false")

  //- 3d_stage
  div(v-if="['3d_stage'].includes(selectedType) && blobURL && ['gltf', 'draco.gltf', 'glb'].includes(assetExt)").wrap-3d-stage-registor
    div.wrap-gltf-uploader
      ItemGltfUploader(ref="assetGltfUploader"
        :gltfPath="blobURL" :defaultAsset="defaultAsset"
        @closeModal="showModal = false" @onReset="onReset")

  //- 3d_object
  div(v-if="['3d_object'].includes(selectedType) && blobURL && ['gltf', 'draco.gltf', 'glb'].includes(assetExt)").wrap-3d-object-registor
    div.wrap-gltf-uploader
      ItemGltfUploader(ref="assetGltfUploader"
        :gltfPath="blobURL" :defaultAsset="defaultAsset"
        @closeModal="showModal = false" @onReset="onReset")

  //- image_object, background
  div(v-if="['image_object', 'background'].includes(selectedType) && blobURL && isImageFile").wrap-bg-registor
    div.wrap-asset-line-art-editor
      div(v-if="!useOriginalData")
        ItemLineArtEditor(ref="assetLineArtEditor"
          v-if="assetURL" :baseImgURL="assetURL" :defaultAsset="defaultAsset")
      div(v-else)
        //- v-img(:assetURL="assetURL")
        ItemImgUploader(ref="assetImgUploader"
          v-if="files[0]" :file="files[0]" :maxSize="{ w: 1200, h: 1200 }")
      div.f.flex-right
        //- v-checkbox(v-model="useOriginalData" label="元の画像を使う")
        v-switch(v-model="useOriginalData" label="元の画像を使う")

  //- effect_background
  div(v-if="['effect_background'].includes(selectedType) && blobURL && isImageFile").wrap-img-registor
    div.wrap-asset-img-uploader
      ItemImgUploader(ref="assetImgUploader"
        v-if="files[0]" :file="files[0]" :maxSize="{ w: 1200, h: 1200 }")

  //- onomatopoeia, manpu
  div(v-if="['onomatopoeia', 'manpu'].includes(selectedType) && blobURL && isImageFile").wrap-img-registor
    div.wrap-asset-img-uploader
      ItemImgUploader(ref="assetImgUploader"
        v-if="files[0]" :file="files[0]" :maxSize="{ w: 320, h: 320 }")

  div(v-if="blobURL").mb4
    div.wrap-form.pt30
      v-text-field(v-model="name"
        :label="formInfo.name.label" :placeholder="formInfo.name.placeholder"
        :hint="`現在の文字数：${name.length}/${nameLimit}`"
        :rules="[() => name.length <= nameLimit ||`現在の文字数：${name.length}/${nameLimit}`]"
        @keydown.stop persistent-placeholder outlined)
      //- v-combobox(v-model="tags"
        :items="tagsCandidates.map(t => t.value)"
        :search-input.sync="search"
        :label="formInfo.tag.label"
        :placeholder="formInfo.tag.placeholder" persistent-placeholder
        hint="タグ名入力後にエンターで追加されます" persistent-hint
        hide-selected multiple small-chips).mb20
      div.mt6.mb18
        ItemCombobox(ref="tagCombobox"
          tagType="asset"
          :initialTags="initialTags" :maxTagsNum="maxTagsNum"
          :label="formInfo.tag.label"
          :placeholder="formInfo.tag.placeholder" hint="タグ入力後にエンターで追加")
      v-textarea(v-model="about"
        :label="formInfo.about.label"
        :placeholder="formInfo.about.placeholder"
        :hint="`現在の文字数：${about.length}/${aboutLimit}`"
        :rules="[() => about.length <= aboutLimit ||`現在の文字数：${about.length}/${aboutLimit}`]"
        rows="2"
        persistent-placeholder outlined
        @keydown.stop)
      div(v-if="selectedType === 'actor'").mb30
        span.label.block.fz14.mb8 性別
        v-radio-group(v-model="actorSex" row)
          v-radio(label="女性" value="female")
          v-radio(label="男性" value="male")
          v-radio(label="その他" value="other")
      //- v-switch(:label="isPublished ? '公開' : '非公開'" v-model="isPublished")
      span.label.block.fz14.mb8 アセットの利用範囲
      div.wrap-terms-of-usage.f.fm.flex-between.mb20
        v-radio-group(v-model="isPublished" row).mb16
          v-radio(label="他の人の漫画でも利用可能" :value="true")
          v-radio(label="自分のみ利用可能" :value="false")
        a(@click="showTermsOfUseSettings = true"
          ).btn-constraints.block.fz14.s-mt12.cursor-pointer 利用条件に制限を設定

        ModalWindow(:showModal="showTermsOfUseSettings"
          @closeModalWindow="showTermsOfUseSettings = false")
          ItemTermsOfUseSettings(:assetType="selectedType"
            :termsOfUse="termsOfUse"
            @updateTermsOfUseSettings="updateTermsOfUseSettings"
            @closeModalWindow="showTermsOfUseSettings = false")
 
  div(v-if="blobURL").wrap-parent-asset.mb40
    span.label.block.fz14.mb8 メインアセット
    ItemParentAsset(:parentAsset="parentAsset" :childAsset="defaultAsset"
      @setParentAsset="setParentAsset")

  div(v-if="blobURL")
    div.wrap-save-btn.pb12
      div(@click="addAsset").btn.w-full.cursor-pointer.f.fh.py12
        div.f.fm
          v-progress-circular(v-if="isSaving" indeterminate
            size="18" width="2" color="white").mr8
          span.text-center {{(isSaving) ? '保存中' : '保存'}}
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
$upload_area_height: 320px;
$photo_studio_height: 60vh;
// $photo_studio_height: 380px;
.wrap-asset-uploader {
  position: relative;
  width: 100%; height: 100%;
  // min-width: 80vw;
  .wrap-upload-area {
    width: 100%;
    height:  $upload_area_height;
    .btn-cancel-upload {
      color: $secondary_text_color;
    }
    .input-file {
      visibility: hidden;
      position: absolute;
    }
    .drag-area {
      width: 100%; height: 100%;
      border-radius: 9px;
      border: dashed 2px $primary_text_color;
      transition: border 200ms linear;
      &.is-enter {
        border: dashed 2px $active_color;
        span {
          color: $active_color;
        }
      }
      .slide-uploader-content {
        pointer-events: none;
      }
    }
  }
  .label, .wrap-reset {
    color: $secondary_text_color;
  }
  .wrap-actor-photo-studio, .wrap-gltf-uploader {
    width: 100%;
    max-height: $photo_studio_height;
    // 仮
    height: 60vh;
  }
  // .wrap-asset-line-art-editor, .wrap-asset-img-uploader {
  //   // 仮
  //   width: 90vw;
  // }
  .wrap-parent-asset {
    .pagent-asset-info {
      border: $basic_border;
      .wrap-main-img {
        width: 60%;
        max-width: 200px;
        max-height: 200px;
      }
      .tag {
        border: $basic_border;
      }
    }
  }
  .btn {
    background: $active_color;
    color: $dark_primary_text_color;
    border-radius: 3px;
  }
  @media only screen and (max-width: $responsive_sp_width) {
    .wrap-terms-of-usage {
      display: block;
    }
  }
}
</style>

<style lang="scss">
@import "@/scss/_variables.scss";

.wrap-asset-uploader {
  // .wrap-asset-uploader {
    // .radiogroup {
      .active {
        label {
          color: $active_color !important;
        }
      }
    // }
  // }

  .wrap-form {
    .v-input__slot {
      margin: 0 !important;
    }
    .v-input--selection-controls {
      margin: 0 !important;
      padding: 0 !important;
      .v-messages {
        display: none;
      }
    }

    .v-application--is-ltr .v-messages {
      display: none;
    }
  }
}
</style>

<script>
import database from '@/database'
import { storage } from '@/components/utils/firebase'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
import studioManager from '@/components/mixin/studioManager'
import gltfManager from '@/components/mixin/gltfManager'

import ModalWindow from '@/components/shared/ModalWindow'

import ItemActorPhotoStudio from '@/components/item/asset-uploader/ItemActorPhotoStudio'
import ItemLineArtEditor from '@/components/item/asset-uploader/ItemLineArtEditor'
import ItemGltfUploader from '@/components/item/asset-uploader/ItemGltfUploader'
import ItemImgUploader from '@/components/item/asset-uploader/ItemImgUploader'
import ItemParentAsset from '@/components/item/asset-uploader/ItemParentAsset'
import ItemTermsOfUseSettings from '@/components/item/asset-uploader/ItemTermsOfUseSettings'
import ItemCombobox from '@/components/item/ItemCombobox'

import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter'
import { handleFileSelect } from '@/plugins/GLTFtoGLB'
import { WebIO } from '@gltf-transform/core'
import { DracoMeshCompression } from '@gltf-transform/extensions'
/* globals DracoEncoderModule */
/* globals DracoDecoderModule */

export default {
  mixins: [studioManager, gltfManager],
  components: {
    ModalWindow,
    ItemActorPhotoStudio, ItemGltfUploader, ItemLineArtEditor,
    ItemImgUploader, ItemParentAsset, ItemTermsOfUseSettings, ItemCombobox
  },
  props: {
    assetType: {
      type: Object,
      default: null
    },
    defaultAsset: {
      type: Object,
      default: null
    },
    parentAsset: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isSaving: false,
      isUploading: false,
      comoleteUpload: false,
      isEnter: false,
      files: [],
      assetExt: null,
      blobURL: null,
      dracoGLTFBlobURL: null,
      assetURL: '',
      selectedType: '',
      useOriginalData: false,
      uploadTask: null,

      // for develpoment
      // isSaving: false,
      // isUploading: false,
      // comoleteUpload: true,
      // isEnter: false,
      // files: [],
      // assetExt: 'vrm',
      // blobURL: '/vrm/minna_ai_comic.vrm',
      // dracoGLTFBlobURL: null,
      // assetURL: '/vrm/minna_ai_comic.vrm',
      // // assetExt: 'gltf',
      // // blobURL: '/gltf/smartphone.gltf',
      // // assetURL: '/gltf/smartphone.gltf',
      // // assetExt: 'glb',
      // // blobURL: '/gltf/sp.glb',
      // // assetURL: '/gltf/sp.glb',
      // selectedType: '',
      // useOriginalData: false,
      // uploadTask: null,

      // isSaving: false,
      // isUploading: false,
      // comoleteUpload: true,
      // isEnter: false,
      // files: [],
      // assetExt: 'jpeg',
      // blobURL: '/jpeg/bg1.jpeg.jpeg',
      // dracoGLTFBlobURL: null,
      // // assetURL: '/jpeg/bg1.jpeg.jpeg',
      // assetURL: 'https://firebasestorage.googleapis.com/v0/b/v-comic-dev.appspot.com/o/sample%2Fbase8.jpeg?alt=media&token=63f82a79-fceb-4738-acbc-4ad578b14492',
      // useOriginalData: false,

      // allowedExts: ['vrm', 'png', 'jpg', 'jpeg'],
      maxByte: 70000000, // 70MB
      uploadProgress: 0,

      // for all asset
      name: '', nameLimit: 140,
      about: '', aboutLimit: 400,
      initialTags: [], maxTagsNum: 10,
      // creditNotion: '',
      isPublished: true,
      termsOfUse: {
        violenceRepresentation: true,
        sexualRepresentation: true,
        individualCommercialUse: true,
        corporateCommercialUse: true,
        creditNotationUnnecessary: true,
        creditNotion: ''
      },
      showTermsOfUseSettings: false,
      isInitialized: false,

      // for vrm
      actorSex: 'female',
    }
  },
  computed: {
    ...mapStateAuth(['uid']),
    isImageFile () {
      return (
        this.assetExt == 'png' || this.assetExt == 'PNG'
        || this.assetExt == 'jpg' || this.assetExt == 'JPG'
        || this.assetExt == 'jpeg' || this.assetExt == 'JPEG'
      )
    },
    allowedExts () {
      if (['actor'].includes(this.selectedType)) return ['vrm']
      if (['3d_object'].includes(this.selectedType)) return ['gltf', 'glb']
      if (['image_object', 'background', 'effect_background', 'onomatopoeia', 'manpu'].includes(this.selectedType)) {
        return ['png', 'PNG', 'jpg', 'JPG', 'jpeg', 'JPEG']
      }
      return []
    },
    allowedExtsText () {
      if (['3d_stage', '3d_object'].includes(this.selectedType)) {
        return 'glb, gltf, gltfファイル一式（*.gltf, *.bin, textures, etc...）'
      } else {
        return this.allowedExts.join(', ')
      }
    },
    formInfo () {
      if (['actor'].includes(this.selectedType)) {
        return {
          name: { label: '名前*', placeholder: '俳優の名前を教えてください！' },
          about: { label: '俳優の紹介', placeholder: '俳優の特徴を紹介しましょう！' },
          tag: { label: 'タグ', placeholder: '例）制服 ' },
          creditNotion: { label: 'クレジット表記', placeholder: '（素材のクレジット表記が必要な場合は記入）' }
        }
      }
      if (['background'].includes(this.selectedType)) {
        return {
          name: { label: '名前*', placeholder: '背景画の名前を入力してください！' },
          about: { label: '背景画について', placeholder: 'この背景画の説明を入力' },
          tag: { label: 'タグ', placeholder: '例）学校 ' },
          creditNotion: { label: 'クレジット表記', placeholder: '（素材のクレジット表記が必要な場合は記入）' }
        }
      }
      if (['effect_background'].includes(this.selectedType)) {
        return {
          name: { label: '名前*', placeholder: '効果背景の名前を入力してください！' },
          about: { label: '効果背景について', placeholder: 'この効果背景の説明を入力' },
          tag: { label: 'タグ', placeholder: '例）驚き ' },
          creditNotion: { label: 'クレジット表記', placeholder: '（素材のクレジット表記が必要な場合は記入）' }
        }
      }
      if (['3d_stage'].includes(this.selectedType)) {
        return {
          name: { label: '名前*', placeholder: 'ステージ名' },
          about: { label: 'アセットについて', placeholder: 'この3Dステージについての説明を入力' },
          tag: { label: 'タグ', placeholder: '例）カフェ' },
          creditNotion: { label: 'クレジット表記', placeholder: '（素材のクレジット表記が必要な場合は記入）' }
        }
      }
      if (['image_object', '3d_object'].includes(this.selectedType)) {
        return {
          name: { label: '名前*', placeholder: 'アセット名' },
          about: { label: 'アセットについて', placeholder: 'このアセットについての説明を入力' },
          tag: { label: 'タグ', placeholder: '例）飲み物 ' },
          creditNotion: { label: 'クレジット表記', placeholder: '（素材のクレジット表記が必要な場合は記入）' }
        }
      }
      if (['onomatopoeia'].includes(this.selectedType)) {
        return {
          name: { label: 'オノマトペの文字*', placeholder: '例）ドンッ！' },
          about: { label: 'オノマトペについて', placeholder: 'このオノマトペの説明を入力' },
          tag: { label: 'タグ', placeholder: '例）驚き ' },
          creditNotion: { label: 'クレジット表記', placeholder: '（素材のクレジット表記が必要な場合は記入）' }
        }
      }
      if (['manpu'].includes(this.selectedType)) {
        return {
          name: { label: '名前*', placeholder: 'モヤモヤ' },
          about: { label: '漫符について', placeholder: 'この漫符の説明を入力' },
          tag: { label: 'タグ', placeholder: '例）驚き ' },
          creditNotion: { label: 'クレジット表記', placeholder: '（素材のクレジット表記が必要な場合は記入）' }
        }
      }
      return null
    },
    handleFileSelectForGLTFtoGLB () {
      return handleFileSelect
    }
  },
  async created () {
    this.selectedType = this.assetType ? this.assetType.type : 'actor'    
    if (this.defaultAsset) this.initializeContentToEditAsset(this.defaultAsset)
    if (this.parentAsset) this.tags = this.parentAsset.tags
  },
  mounted () {
    this.isInitialized = true
  },
  methods: {
    onReset () {
      this.isSaving = false
      this.isUploading = false
      this.comoleteUpload = false
      this.isEnter = false
      this.files = []
      this.assetExt = null
      this.blobURL = null
      this.dracoGLTFBlobURL = null
      this.dracoGLTFBlobURL = null
      this.assetURL = ''
      if (this.uploadTask) this.uploadTask.cancel()
    },
    // アセットを編集する場合はアップロード後の状態を表示する
    async initializeContentToEditAsset (asset) {
      // アップローダーの初期設定
      this.assetURL = asset.assetURL
      this.blobURL = asset.assetURL
      this.assetExt = asset.extension
      this.comoleteUpload = true
      // フォームの情報
      this.name = asset.name
      this.about = asset.about
      this.initialTags = asset.tags
      this.isPublished = asset.status === 'public'
      // this.creditNotion = this.creditNotion
      if (this.selectedType === 'actor') {
        this.actorSex = asset.sex
      }

      if (asset.termsOfUse) {
        const termsOfUse = asset.termsOfUse
        this.termsOfUse.violenceRepresentation = termsOfUse.violenceRepresentation
        this.termsOfUse.sexualRepresentation = termsOfUse.sexualRepresentation
        this.termsOfUse.individualCommercialUse = termsOfUse.individualCommercialUse
        this.termsOfUse.corporateCommercialUse = termsOfUse.corporateCommercialUse
        this.termsOfUse.creditNotationUnnecessary = termsOfUse.creditNotationUnnecessary
        this.termsOfUse.creditNotion = termsOfUse.creditNotion
      }

      if (asset.useOriginalData) this.useOriginalData = asset.useOriginalData

      // 「元の画像を使う」をチェックされた時用に元の画像をFileに変換しておく
      if (this.isImageFile) {
        const res = await fetch(asset.assetURL)
        const buf = await res.arrayBuffer()
        const file = new File([buf], 'original-img.png', { type: 'image/png' })
        this.files = []
        this.files[0] = file
      }
    },
    onFileChange (e) {
      this.files = e.target.files || e.dataTransfer.files
      if (!this.files[0]) return

      const fileName = this.files[0].name
      this.assetExt = this.getExt(fileName)
      
      if (!this.allowedExts.includes(this.assetExt)) {
        const name = this.assetTypes
          .filter(a => a.type === this.selectedType)[0].name
        alert(`${name}としてアップロードできるファイルは${this.allowedExts.join(', ')}のみです`)
        return
      }
      
      this.uploadFile()
    },
    onDragArea () {
      // BUG: なぜかdataが正常に更新されない
      const inputFile = this.$refs.inputFile
      inputFile.click()
    },
    async dropFile (e) {
      this.isEnter = false
      this.files = e.target.files || e.dataTransfer.files
      if (!this.files[0]) return

      if (this.files[0].size > this.maxByte) {
        this.$root.$emit('showNavigationMessage', {
          message: `${this.maxByte / 1000000}MB以内のデータをアップロードしてください`,
          showOK: true
        })
        // alert(`${this.maxByte / 1000000}MB以内のデータをアップロードしてください`)
        return
      }

      const fileName = this.files[0].name
      this.assetExt = this.getExt(fileName)
      if (!this.allowedExts.includes(this.assetExt)
       && !['3d_stage', '3d_object'].includes(this.selectedType)) {
        const name = this.assetTypes
          .filter(a => a.type === this.selectedType)[0].name
        alert(`${name}としてアップロードできるファイルは${this.allowedExts.join(', ')}のみです`)
        return
      } else if (['3d_stage', '3d_object'].includes(this.selectedType)) {
        if (this.assetExt === 'glb') {
          try {
            // はじめからglbファイルだった場合
            this.isUploading = true
            // draco compression
            this.dracoGLTFBlobURL = await this.compressGLBtoDracoGLTF(this.files[0])
            this.assetExt = 'draco.gltf'
          } catch (err) {
            alert(`このファイルは利用できません。エラーコード：${err}`)
            this.onReset()
            this.isUploading = false
            return
          }
        } else {
          try {
            this.isUploading = true
            // GLTFファイル一式をGLBにパックしてテクスチャを圧縮
            const resultBlobGLB = await this.handleFileSelectForGLTFtoGLB(e)
            // console.log('resultBlobGLB:', resultBlobGLB)

            // draco compression
            this.dracoGLTFBlobURL = await this.compressGLBtoDracoGLTF(resultBlobGLB)
            this.assetExt = 'draco.gltf'
          } catch (err) {
            alert(`このファイルは利用できません。エラーコード：${err}`)
            this.onReset()
            this.isUploading = false
            return
          }
        }
        // gltf exporterを用いてサイズを最適化
        // this.uploadFile()はoptimizeGLTFModelSizeの中で呼んでる（exporter.parseがawait非対応なため）
        this.optimizeGLTFModelSize(this.dracoGLTFBlobURL)
        return
      }

      this.uploadFile()
    },
    async optimizeGLTFModelSize (dracoGLTFBlobURL) {
      const progressFunc = (progress) => {
        const progressPercent = Math.floor(100.0 * (progress.loaded / progress.total))
        // console.log('progressPercent:', progressPercent)
      }
      const errorFunc = (error) => {
        alert(error.type)
        console.error(error)
      }
      const gltf = await this.loadGLTFwithDracoLoader({ 
        path: dracoGLTFBlobURL, progressFunc, errorFunc
      })

      const box3 = new THREE.Box3().setFromObject(gltf.scene)
      const wSize = box3.max.x - box3.min.x
      let initialScale
      // const initialScale = 4.0 / wSize // サイズを4.0にする
      if (this.selectedType === '3d_stage') initialScale = this.initialSize3dStage / wSize
      if (this.selectedType === '3d_object') initialScale = this.initialSize3dObject / wSize
      gltf.scene.scale.set(initialScale, initialScale, initialScale)

      const modelPositionOffset = box3.getCenter(new THREE.Vector3())
      gltf.scene.position.set(
        -modelPositionOffset.x * initialScale,
        -modelPositionOffset.y * initialScale,
        -modelPositionOffset.z * initialScale
      )

      const createBlobFromExportedGLTFAndUploadFile = (gltf) => {
        if (gltf instanceof ArrayBuffer) {
          const dracoBlob = new Blob([gltf])
          this.dracoGLTFBlobURL = URL.createObjectURL(dracoBlob)
        } else {
          const str = JSON.stringify(gltf)
          const bytes = new TextEncoder().encode(str)
          const dracoBlob = new Blob([bytes])
          this.dracoGLTFBlobURL = URL.createObjectURL(dracoBlob)
          // const output = JSON.stringify(gltf, null, 2)
          // console.log(output)
        }
        this.uploadFile()
      }

      const exporter = new GLTFExporter()
      const options = { binary: true }
      exporter.parse(
        gltf.scene,
        createBlobFromExportedGLTFAndUploadFile,
        (error) => {
          // console.log('An error happened:', error)
        },
        options
      )
    },
    async uploadFile () {
      const file = this.files[0]
      // console.log('file:', file)

      // if (this.getExt === 'gltf') の時は圧縮してfileを更新

      if (['3d_stage', '3d_object'].includes(this.selectedType)) {
        this.blobURL = this.dracoGLTFBlobURL
      } else {
        this.blobURL = URL.createObjectURL(file)
      }
      
      // すでにmainImgがデフォルトアセットによって存在した場合は撮影モードに移行
      if (this.defaultAsset
        && ['actor', '3d_stage', '3d_object'].includes(this.selectedType)) {
        this.$nextTick(() => {
          if (['actor'].includes(this.selectedType)) {
            const actorPhotoStudio = this.$refs.actorPhotoStudio
            if (actorPhotoStudio) actorPhotoStudio.onRetakePhoto()
          }
          if (['3d_stage', '3d_object'].includes(this.selectedType)) {
            const assetGltfUploader = this.$refs.assetGltfUploader
            if (assetGltfUploader) assetGltfUploader.onRetakePhoto()
          }
        })
      }

      this.isUploading = true
      try {
        // const url = URL.createObjectURL(file)
        const storageRef = storage.ref()
        const fileId = this.getUniqueStr()

        const ref = storageRef.child(`USER/${this.uid}/ASSET/${this.assetExt}/${fileId}.${this.assetExt}`)
        const blob = await fetch(this.blobURL).then(r => r.blob())
        this.uploadTask = ref.put(blob)
        const succsessUpload = async () => {
          this.assetURL = await this.uploadTask.snapshot.ref
            .getDownloadURL().then((downloadURL) => downloadURL)
          this.isUploading = false
          this.comoleteUpload = true
        }
        await this.uploadTask.on('state_changed', snapshot => {
          this.uploadProgress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          // console.log('Upload is ' + this.uploadProgress + '% done')
        }, (err) => {
          // Handle unsuccessful uploads
          console.error(err)
          this.resetSettings()
          this.$root.$emit('showNavigationMessage', {
            message: 'データのアップロードが停止しました', showOK: true
          })
          return err
        }, succsessUpload)
      } catch (error) {
        // console.log(error)
      }
    },
    async addAsset () {
      if (this.isSaving) return

      let go = true
      if (!this.name || !this.assetURL) {
        this.$root.$emit('showNavigationMessage', {
          message: '必要項目を入力してください', showOK: true
        })
        go = false
      }
      if (this.name.length > this.nameLimit) {
        this.$root.$emit('showNavigationMessage', {
          message: `アセット名は${this.nameLimit}字以内に設定してください`, showOK: true
        })
        return
      }
      if (this.about.length > this.aboutLimit) {
        this.$root.$emit('showNavigationMessage', {
          message: `${this.formInfo.about.label}は${this.aboutLimit}字以内に設定してください`, showOK: true
        })
        return
      }
      if (this.$refs.tagCombobox.tags.length > this.maxTagsNum) {
        this.$root.$emit('showNavigationMessage', {
          message: `タグは${this.maxTagsNum}個以内で設定してください`, showOK: true
        })
        return
      }
      if (this.isUploading) {
        this.$root.$emit('showNavigationMessage', {
          message: 'アップロードが完了されるまでお待ちください', showOK: true
        })
        go = false
      }
      // if (!this.tags[0]) {
      //   go = confirm('タグが入力されていません。このまま保存しますか？ * タグを追加しておくと後から検索したり、見つけてもらいやすくなります')
      // }
      if (!go) {
        this.isSaving = false
        return
      }

      this.isSaving = true

      let asset = {
        name: this.name,
        about: this.about,
        termsOfUse: this.termsOfUse,
        tags: this.$refs.tagCombobox.tags,
        type: this.selectedType,
        extension: this.assetExt,
        assetURL: this.assetURL,
        status: this.isPublished ? 'public' : 'private',
        createdBy: this.uid,
        updatedAt: new Date(),
        // 更新と分けた
        // followers: [],
        // importedNum: 0,
        // adoptedNum: 0,
        // followerNum: 0,
        // createdAt: new Date(),
        // latestAdoptedAt: new Date()
      }

      if (this.selectedType === 'actor') {
        const actorPhotoStudio = this.$refs.actorPhotoStudio
        asset.mainImg = actorPhotoStudio.vrmMainImg
        const meta  = actorPhotoStudio.vrm.meta
        asset.license = {
          allowedUserName: meta.allowedUserName ? meta.allowedUserName : '',
          author: meta.author ? meta.author : '',
          commercialUssageName: meta.commercialUssageName ? meta.commercialUssageName : '',
          contactInformation: meta.contactInformation ? meta.contactInformation : '',
          licenseName: meta.licenseName ? meta.licenseName : '',
          otherLicenseUrl: meta.otherLicenseUrl ? meta.otherLicenseUrl : '',
          otherPermissionUrl: meta.otherPermissionUrl ? meta.otherPermissionUrl : '',
          reference: meta.reference ? meta.reference : '',
          sexualUssageName: meta.sexualUssageName ? meta.sexualUssageName : '',
          title: meta.title ? meta.title : '',
          version: meta.version ? meta.version : '',
          violentUssageName: meta.violentUssageNam ? meta.violentUssageNam : ''
        }
        asset.sex = this.actorSex
        asset.photoPose = actorPhotoStudio.pose
        asset.photoBlendShape = actorPhotoStudio.blendShape
        asset.camera = actorPhotoStudio.getCameraParams()
        // asset.orbitControlsDefault = actorPhotoStudio.getOrbitControlsParams()
        asset.defaultOrbitControls = actorPhotoStudio.getOrbitControlsParams()
        if (!asset.mainImg) {
          this.$root.$emit('showNavigationMessage', {
            message: '俳優の写真を撮影してください', showOK: true
          })
          this.isSaving = false
          return
        }
      }
      
      if (['3d_stage', '3d_object'].includes(this.selectedType)) {
        const assetGltfUploader = this.$refs.assetGltfUploader
        asset.mainImg = assetGltfUploader.mainImg
        asset.positionOffset = {
          x: assetGltfUploader.positionOffset.x,
          y: assetGltfUploader.positionOffset.y,
          z: assetGltfUploader.positionOffset.z
        }
        asset.originalInitialSize = assetGltfUploader.originalInitialSize
        asset.camera = assetGltfUploader.getCameraParams()
        asset.defaultOrbitControls = assetGltfUploader.getOrbitControlsParams()
        asset.defaultAmbientLight = {
          color: { r: 1, g: 1, b: 1 },
          intensity: assetGltfUploader.ambientLightIntensity
        }
        if (assetGltfUploader.needsLineGroup) {
          asset.defaultLineSegmentsThrehold = assetGltfUploader.edgeDegreeThrehold
        }
        if (assetGltfUploader.emissiveColor) {
          asset.defaultEmissiveColor = assetGltfUploader.emissiveColor
        }
        if (!asset.mainImg) {
          this.$root.$emit('showNavigationMessage', {
            message: 'サムネイルを撮影してください', showOK: true
          })
          this.isSaving = false
          return
        }
      }

      if (['image_object', 'background'].includes(this.selectedType)) {
        if (!this.useOriginalData) {
          const assetLineArtEditor = this.$refs.assetLineArtEditor
          const base64 = assetLineArtEditor.getResultImage()
          const storageRef = storage.ref()
          const ref = storageRef.child(`USER/${this.uid}/ASSET/${this.assetExt}/${this.getUniqueStr()}`)
          const imgURL = await ref
            .putString(base64.split(',')[1], 'base64', {contentType: 'image/png'})
            .then(async snapshot => {
              return await snapshot.ref.getDownloadURL().then(async downloadURL => downloadURL)
            })
          asset.mainImg = imgURL
          asset.defaultImg = imgURL
          asset.screen = assetLineArtEditor.screen
          asset.cannyParam = assetLineArtEditor.cannyParam
          asset.grayScaleParam = assetLineArtEditor.grayScaleParam
        } else {
          const assetImgUploader = this.$refs.assetImgUploader
          if (!assetImgUploader.imgURL) {
            this.$root.$emit('showNavigationMessage', {
              message: 'アップロード中です', showOK: true
            })
            this.isSaving = false
            return
          }
          asset.mainImg = assetImgUploader.imgURL
          asset.defaultImg = assetImgUploader.imgURL
        }
        asset.useOriginalData = this.useOriginalData
      }

      if (['onomatopoeia', 'manpu', 'effect_background'].includes(this.selectedType)) {
        const assetImgUploader = this.$refs.assetImgUploader
        if (!assetImgUploader.imgURL) {
          this.$root.$emit('showNavigationMessage', {
            message: 'アップロード中です', showOK: true
          })
          this.isSaving = false
          return
        }
        asset.mainImg = assetImgUploader.imgURL
        asset.defaultImg = assetImgUploader.imgURL
        asset.useOriginalData = true
      }

      // 将来的にparentAssetを複数追加できるようにした場合のコード
      // if (this.parentAsset) {
      //   if (this.defaultAsset && this.defaultAsset.parentAsset) {
      //     if (!this.defaultAsset.parentAsset.includes(this.parentAsset.id)) {
      //       asset.parentAsset = this.defaultAsset
      //         .parentAsset.concat(this.parentAsset.id)
      //     }
      //   } else {
      //     asset.parentAsset = [this.parentAsset.id]
      //   }
      // }
      if (this.parentAsset) asset.parentAsset = [this.parentAsset.id]

      let assetId
      if (!this.defaultAsset) {
        // 新規作成の場合
        asset.importedNum = 0
        asset.adoptedNum = 0
        asset.followerNum = 0
        asset.followers = []
        asset.createdAt = new Date()
        asset.latestAdoptedAt = new Date()
        console.log('asset', asset)
        assetId = await database.assetCollection().add(asset)
        asset.id = assetId
      } else {
        // 更新の場合
        assetId = this.defaultAsset.id
        asset.createdAt = this.defaultAsset.createdAt.toDate()
        if (this.defaultAsset.importedNum) asset.importedNum = this.defaultAsset.importedNum
        if (this.defaultAsset.followerNum) asset.followerNum = this.defaultAsset.followerNum
        if (this.defaultAsset.adoptedNum) asset.adoptedNum = this.defaultAsset.adoptedNum
        if (this.defaultAsset.followers) asset.followers = this.defaultAsset.followers
        if (this.defaultAsset.latestAdoptedAt) asset.latestAdoptedAt = this.defaultAsset.latestAdoptedAt

        let archieve = {
          assetURL: this.defaultAsset.assetURL,
          archievedAt: new Date()
        }
        if (this.defaultAsset.defaultImg) archieve.defaultImg = this.defaultAsset.defaultImg
        if (this.defaultAsset.assetArchives) {
          let assetArchives = this.defaultAsset.assetArchives
          assetArchives.unshift(archieve)
          asset.assetArchives = assetArchives
        } else {
          asset.assetArchives = [archieve]
        }
        console.log('asset', asset)
        await database.assetCollection().update(assetId, asset)
      }

      if (this.$route.name === 'edit-frame') {
        const rp = this.$route.params

        // 並び順を更新
        const frameRef = database.frameCollection(rp.comicId, rp.episodeId, rp.pageId)
        let frame = await frameRef.findById(rp.frameId)
        if (!frame.assetOrder[this.selectedType]) frame.assetOrder[this.selectedType] = []
        frame.assetOrder[this.selectedType].unshift(assetId)

        // this.frameとthis.assetsを更新する
        this.$root.$emit('updateImportedAssetsAfterAddingNewAsset', { 
          frame, newAsset: { id: assetId, ...asset }
        })
        await database
          .frameCollection(rp.comicId, rp.episodeId, rp.pageId)
          .update(rp.frameId, { assetOrder: frame.assetOrder })

        const importObj = {
          assetId,
          comicId: rp.comicId,
          episodeId: rp.episodeId,
          pageId: rp.pageId,
          frameId: rp.frameId,
          createdBy: this.uid,
          createdAt: new Date(),
          updatedAt: new Date()
        }
        await database.importCollection(assetId).add(importObj)
      }
      
      this.isSaving = false

      if (!this.defaultAsset) {
        this.$root.$emit('showNavigationMessage', {
          message: '新しいアセットとして追加されました！', showOK: true
        })
      } else {
        this.$root.$emit('showNavigationMessage', {
          message: 'アセットが更新されました！', showOK: true
        })
        this.$router.go(-1)
      }
      this.$emit('completeSaveAsset', asset)
    },
    resetSettings () {
      this.isSaving = false
      this.isUploading = false
      this.comoleteUpload = false
      this.isEnter = false
      this.files = []
      this.assetExt = null
      this.blobURL = null
      this.assetURL = ''
      this.isPublished = false
      this.termsOfUse = {
        violenceRepresentation: true,
        sexualRepresentation: true,
        individualCommercialUse: true,
        corporateCommercialUse: true,
        creditNotationUnnecessary: true,
        creditNotion: ''
      }
    },
    setParentAsset (asset) {
      this.$emit('setParentAsset', asset)
    },
    getExt (filename) {
      const pos = filename.lastIndexOf('.')
      if (pos === -1) return ''
      return filename.slice(pos + 1)
    },
    updateTermsOfUseSettings (termsOfUse) {
      this.termsOfUse = termsOfUse
    }
  }
}
</script>
